var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 15.5455V2.45455C1 2.06878 1.15325 1.69881 1.42603 1.42603C1.69881 1.15325 2.06878 1 2.45455 1H15.5455C15.9312 1 16.3012 1.15325 16.574 1.42603C16.8468 1.69881 17 2.06878 17 2.45455V15.5455C17 15.9312 16.8468 16.3012 16.574 16.574C16.3012 16.8468 15.9312 17 15.5455 17H2.45455C2.06878 17 1.69881 16.8468 1.42603 16.574C1.15325 16.3012 1 15.9312 1 15.5455Z",
    stroke: "#6E8CA0",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1818 5.3636H14.0909M11.1818 11.5454H14.0909M11.1818 13.7272H14.0909M3.90909 5.3636H5.36363M5.36363 5.3636H6.81818M5.36363 5.3636V3.90906M5.36363 5.3636V6.81815M4.33527 13.6647L5.36363 12.6363M5.36363 12.6363L6.39272 11.608M5.36363 12.6363L4.33527 11.608M5.36363 12.6363L6.39272 13.6647",
    stroke: "#6E8CA0",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.67230a64730d30519d7639d827d80e6a.svg";
export { ForwardRef as ReactComponent };